import {HTTPError} from "platformed-client";
import externalApi from "../../../api/external";
import {GetGraphQuery, ContentId, AccountMin} from "platformed-client/types";
import {param, typedQuery} from "../../typing";

export const trustCenterDocuments = typedQuery(
  ["external", "trustCenterDocuments", param<AccountMin>("account")],
  async account => {
    return await externalApi.trustCenters.listDocuments(account);
  },
);

export const trustCenterConfig = typedQuery(
  ["external", "trustCenterConfig", param<AccountMin>("account")],
  async account => {
    return await externalApi.trustCenters.getConfig(account);
  },
);

export const trustCenterMissingAuth = typedQuery(
  ["external", "trustCenterMissingAuth", param<AccountMin>("account")],
  async account => {
    try {
      await externalApi.trustCenters.getConfig(account);
      return null;
    } catch (ex) {
      if (ex instanceof HTTPError && ex.response.status === 401) {
        return ex.json?.sub_type as "missing_authorization" | "incorrect_email_or_password";
      }
      throw ex;
    }
  },
);

export const trustCenterFaq = typedQuery(
  ["external", "trustCenterFaq", param<AccountMin>("account")],
  async account => {
    return await externalApi.trustCenters.getFaq(account);
  },
);

export const trustCenterAiFaq = typedQuery(
  ["external", "trustCenterAiFaq", param<AccountMin>("account")],
  async account => {
    return await externalApi.trustCenters.getAiFaq(account);
  },
);

export const trustCenterContent = typedQuery(
  ["external", "trustCenterContent", param<AccountMin>("account"), param<ContentId>("contentId")],
  async (account, contentId) => {
    return await externalApi.trustCenters.getContent(account, contentId);
  },
);

export const trustCenterGraph = typedQuery(
  ["external", "trustCenterGraph", param<AccountMin>("account"), param<GetGraphQuery>("query")],
  async (account, query) => {
    return await externalApi.trustCenters.getGraph(account, query);
  },
);

export const trustCenterSchema = typedQuery(
  ["external", "trustCenterSchema", param<AccountMin>("account")],
  async account => {
    return await externalApi.trustCenters.getSchema(account);
  },
);
